import { getVocabulary } from "components/Vocabulary";
import React from "react";
import { CustomFindingColumn } from "types/tenantConfig";

import ACMultiSelectCheckbox from "ac-components/ac-multi-select-checkbox";

import {
  customColumnsToWidgetOptions,
  toWidgetOptions,
} from "./widgetColumnUtils";

const SUBPRODUCT_SUMMARY_COLUMN_DEFS = [
  { key: "groups", getLabel: () => getVocabulary("group") },
  {
    key: "parentName",
    getLabel: () => getVocabulary("product"),
  },
  {
    key: "name",
    getLabel: () => getVocabulary("subProduct"),
    disabled: true,
    existing: true,
  },
  { key: "status", getLabel: () => "Status", existing: true },
  { key: "score", getLabel: () => getVocabulary("riskScore"), existing: true },
  { key: "findings", getLabel: () => "Findings", existing: true },
  { key: "types", getLabel: () => "Type", existing: true },
  { key: "otherTags", getLabel: () => "Tags", existing: true },
  {
    key: "teamName",
    getLabel: () => getVocabulary("team", true),
    existing: true,
  },
  { key: "toolStatus", getLabel: () => "Tool Status", existing: true },
  { key: "businessOwner", getLabel: () => getVocabulary("businessOwner") },
  {
    key: "engineeringOwner",
    getLabel: () => getVocabulary("engineeringOwner"),
  },
  {
    key: "securityOwner",
    getLabel: () => getVocabulary("securityOwner", true),
  },
  { key: "supportOwner", getLabel: () => getVocabulary("supportOwner") },
  { key: "complianceOwner", getLabel: () => getVocabulary("complianceOwner") },
];

export const SUBPRODUCT_SUMMARY_COLUMN_KEYS =
  SUBPRODUCT_SUMMARY_COLUMN_DEFS.filter((i) => i.existing).map((d) => d.key);

export const getSubproductSummaryColumnsForWidgetOptions = (
  customColumns: CustomFindingColumn[] = [],
) => [
  ...toWidgetOptions(SUBPRODUCT_SUMMARY_COLUMN_DEFS),
  ...customColumnsToWidgetOptions(customColumns),
];

export const getSubproductSummaryColumnsSelectionField = (
  customColumns: CustomFindingColumn[] = [],
) => {
  return {
    name: "activeColumnKeys",
    label: `${getVocabulary("subProduct")} Summary Columns`,
    render: () => (
      <ACMultiSelectCheckbox
        options={getSubproductSummaryColumnsForWidgetOptions(customColumns)}
      />
    ),
  };
};
